import { Mediator, app, ojs } from "modular-openscriptjs";
import { approved, inform, processStart, processEnd, eParse } from "../helpers";
import { STRINGS, routes, api } from "../declarations";

const broker = app("broker");
const $e = app("$e");

export default class Surplus extends Mediator {
	$$surplus = {
		needs: {
			positiveReimbursement: (ed, event) =>
				this.send($e.surplus.needs.form, ed),
			processReimbursement: (ed, event) =>
				this.makeReimbursement(ed, event),
		},

		is: {
			confirming: (ed, event) => {
				this.confirmReimbursement(ed, event);
			},
		},

		reimbursementCompleted_reimbursementFailed: (ed, event) => {
			processEnd();
			purCxt.additionalAmount.value = 0;
		},
	};

	// shouldRegister() {
	// 	return window.adminFilesLoaded == true;
	// }

	async makeReimbursement(ed, event) {
		if (
			!approved(
				event,
				ed,
				"You want to make this reimbursement? It cannot be undone"
			)
		) {
			return;
		}

		let message = eParse(ed).message;

		let type = message.get("type", "till");

		if (
			!this[`${type}Checked`](
				message.get(type),
				message.get("account_number", null)
			)
		) {
			return this.send($e.surplus.has.reimbursementError, ed);
		}

		purCxt.paymentInfo.mpesaType = type;
		purCxt.paymentInfo.mpesaInfo[type].number = message.get(type, "");
		purCxt.paymentInfo.mpesaInfo[type].account = message.get(
			"account_number",
			""
		);

		let information = message.getAll();
		information.number = message.get(type);
		information.method = "mpesa";

		let data = { information };

		processStart({ title: "Making Reimbursement" });

		let res = await api.post(
			`/riders/${routes.orderPaymentSurpluses}/${message.surplusId}/reimburse`,
			data
		);

		if (!res) {
			processEnd();
			return this.send($e.surplus.has.reimbursementError, ed);
		}

		processEnd();

		let newEd = eParse(ed);
		newEd.meta.put("paymentId", res.data.response.paymentId);
		newEd.meta.put(
			"surplusId",
			res.data.response.metadata.order_surplus_id
		);

		return this.send($e.surplus.is.confirming, newEd.encode());
	}

	async confirmReimbursement(ed, event) {
		setTimeout(
			(() => {
				processStart({ title: "Confirming Reimbursement" });
				this.checkPayment(ed, event);
			}).bind(this),
			5000
		);
	}

	async checkPayment(ed, event) {
		const { meta } = eParse(ed);
		const paymentId = meta.get("paymentId");

		let res = await api.get(`${routes.payments}/${paymentId}`);

		if (!res) {
			return this.broadcast($e.surplus.reimbursementFailed, ed);
		}

		const payment = res.data.payment;
		let status = payment.status;

		if (status in { processing: true, pending: true }) {
			inform("Awaiting Reimbursement completion");

			return setTimeout(
				(() => {
					this.checkPayment(ed, event);
				}).bind(this),
				2000
			);
		}

		if (status in { failed: true, refunded: true }) {
			inform("Reimbursement Failed/Refunded", STRINGS.ERROR);

			return this.broadcast($e.surplus.reimbursementFailed, ed);
		}

		inform(res.message, STRINGS.SUCCESS);
		return this.broadcast($e.surplus.reimbursementCompleted, ed);
	}

	tillChecked(number) {
		if (!/^\d{6,7}$/.test(number)) {
			inform("Till number is invalid", STRINGS.ERROR);
			return false;
		}

		return true;
	}

	phoneChecked(phone) {
		if (!/^\d{9,16}$/.test(phone)) {
			inform("Phone number is invalid", STRINGS.ERROR);
			return false;
		}

		return true;
	}

	transactionChecked(transactionId) {
		if (!/^\w+$/.test(transactionId)) {
			inform("Transaction ID is invalid", STRINGS.ERROR);
			return false;
		}

		return true;
	}

	paybillChecked(paybill, accountNumber) {
		if (!/^\d{6,7}$/.test(paybill)) {
			inform("Paybill number is invalid", STRINGS.ERROR);
			return false;
		}

		if (!/^\w{1,20}$/.test(accountNumber)) {
			inform("Paybill account number is invalid", STRINGS.ERROR);
			return false;
		}

		return true;
	}
}

ojs(Surplus);
